const messageConstants = {};

messageConstants.SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
messageConstants.SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE';
messageConstants.CLEAR_MESSAGES = 'CLEAR_MESSAGES';

export default messageConstants;



/** WEBPACK FOOTER **
 ** ./src/constants/message.js
 **/